import React from "react"
import Select from "react-select"

const MENU_HEIGHT = 320

export const condominioSelectStyles = {
  container: provided => ({
    ...provided,
    minWidth: "245px",
  }),
  control: provided => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  menu: provided => ({
    ...provided,
    backgroundColor: "#fff",
    color: "#000",
  }),
  menuPortal: provided => ({
    ...provided,
    zIndex: 9999,
  }),
  menuList: provided => ({
    ...provided,
    maxHeight: MENU_HEIGHT,
    overflowY: "auto",
  }),
}

export const empresasToSelectOptions = empresas => {
  const seen = new Set()
  const options = []
  ;(empresas || []).forEach(item => {
    const value = item?.OID_EMPRESA ?? item?.value
    if (value == null || value === "") return
    const key = String(value)
    if (seen.has(key)) return
    seen.add(key)
    options.push({
      value: key,
      label:
        item.NM_RAZAO_SOCIAL ||
        item.label ||
        `Condomínio ${key}`,
    })
  })
  return options
}

const CondominioSelect = ({
  inputId,
  options = [],
  value,
  onChange,
  isDisabled = false,
  isClearable = false,
  placeholder = "Selecione...",
}) => (
  <Select
    inputId={inputId}
    classNamePrefix="select"
    options={options}
    value={value}
    onChange={onChange}
    isDisabled={isDisabled}
    isClearable={isClearable}
    isSearchable
    placeholder={placeholder}
    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
    menuPosition="fixed"
    menuShouldScrollIntoView={false}
    maxMenuHeight={MENU_HEIGHT}
    styles={condominioSelectStyles}
    noOptionsMessage={() => "Nenhum condomínio encontrado"}
    filterOption={(option, rawInput) => {
      const q = (rawInput || "").trim().toLowerCase()
      if (!q) return true
      return String(option.label || "")
        .toLowerCase()
        .includes(q)
    }}
  />
)

export default CondominioSelect
